import { render, staticRenderFns } from "./FileUploadToAI.vue?vue&type=template&id=6daac3a9"
import script from "./FileUploadToAI.vue?vue&type=script&lang=js"
export * from "./FileUploadToAI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports